import { createFileRoute } from '@tanstack/react-router'
import { ReceivablesPage } from '@/features/receivables/receivables-page'

export const Route = createFileRoute('/_authenticated/receivables/')({
  staticData: { title: 'AR Invoices' },
  component: ReceivablesPage,
})
